<fgb-banner [title]="'gallery.page.banner' | translate"></fgb-banner>

<div class="container text-center pt-4">
  <!--Worksheets-->
  <fgb-worksheet-list [colOverride]="'col-md-6'"></fgb-worksheet-list>
</div>
 